export const ENTITY_TYPE_OPTIONS = [
  "Credit Institution",
  "Payment Institution",
  "Account Information Service Provider",
  "Electronic Money Institution",
  "Investment Firm",
  "Crypto-asset Service Provider",
  "Central Securities Depository",
  "Central Counterparty",
  "Trading Venue",
  "Trade Repository",
  "Manager of Alternative Investment Funds",
  "Management Company",
  "Data Reporting Service Provider",
  "Insurance Undertaking or Reinsurance Undertaking",
  "Insurance Intermediary, Reinsurance Intermediary, or Ancillary Insurance Intermediary",
  "Institution for Occupational Retirement Provision",
  "Credit Rating Agency",
  "Administrator of Critical Benchmarks",
  "Crowdfunding Service Provider",
  "Securitisation Repository",
  "ICT Third-Party Service Provider",
  "Other financial entity"
] as const;

export type EntityType = typeof ENTITY_TYPE_OPTIONS[number];
